export default {
  signIn: {
    title: 'PLEASE LOGIN TO IDEXLAB',
    sub_title: 'Innovate faster, innovate better!',
    form_email: {
      label: 'Email',
      place_holder: 'example@gmail.com',
      title: 'Please enter your email'
    },
    form_password: {
      label: 'Password',
      place_holder: '********',
      title: 'Please enter your password'
    },
    form_remember: {
      label: 'Remember me',
      help_block: 'if this is a private computer',
    },
    form: {
      login: 'Login',
      register: 'Register'
    }
  },
  signUp: {
    title: 'Sign up',
    form_firstName: {
      label: 'First Name',
      place_holder: '',
      title: 'Please enter your First Name',
      required: 'First Name is required'
    },
    form_lastName: {
      label: 'Last Name',
      place_holder: '',
      title: 'Please enter your Last Name',
      required: 'Last Name is required'
    },
    form_email: {
      label: 'Email',
      place_holder: '',
      title: 'Please enter your email',
      required: 'Email is required'
    },
    form_phone: {
      label: 'Phone Number',
      place_holder: '',
      title: 'Please enter your phone number',
      required: 'Phone Number is required',
      help_block: 'We’ll use your number for account security. It won’t be visible to others.'
    },
    form_emailConfirm: {
      label: 'Repeat Email Address',
      place_holder: '',
      title: 'Please confirm your email',
      required: 'Email is required and must be the same'
    },
    form_password: {
      label: 'Password',
      place_holder: '',
      title: '',
      required: 'Password is required'
    },
    form_passwordConfirm: {
      label: 'Repeat Email Password',
      place_holder: '',
      title: 'Please confirm your password',
      required: 'Password is required and must be the same'
    },
    form_company: {
      label: 'Organisation Name',
      place_holder: '',
      title: 'Please enter your organisation name'
    },
    form_website: {
      label: 'Website',
      place_holder: '',
      title: 'Please enter your company website'
    },
    form_select_goal: {
      label: 'What is the goal of your sign up ?',
      items: {
        0: 'Looking for informations, just to know what can be achieved through Open Innovation',
        1: 'Facing a technical question, I am looking for answers',
        2: 'Interested in the EU project OpeniSME',
        3: 'Already customer or partner',
        4: 'Other'
      },
      title: ''
    },
    form_checkbox_termsOfUse: {
      label: 'I agree to ideXlab <a target="_blank" href="https://www.idexlab.com/wpautoterms/terms-and-conditions/">terms of use</a> <span style="color: red">*</span>'
    },
    form_checkbox_news: {
      label: 'Send me news from time to time'
    },
    form: {
      register: 'Continue',
      cancel: 'Cancel'
    },
    userCreated: {
      title: 'Thanks for your registration',
      sub_title: 'The account has been successfully created',
      info: 'An email has been sent to {email}. The embedded link must be clicked to activate the account.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translate/en.js